import React from 'react'
import { graphql } from 'gatsby'
import Page from '../components/page'
import { TransitionState } from 'gatsby-plugin-transition-link'
import TransitionLink from 'gatsby-plugin-transition-link'

import posed from 'react-pose'
import styled from 'styled-components'

const PageTransitionStates = posed.div({
  startState: {
    opacity: 0,
    x: -100,
    transition: {
      type: 'spring',
      stiffness: 200,
      damping: 50,
    },
  },
  exitedState: {
    opacity: 0,
    x: 100,
    transition: {
      type: 'spring',
      stiffness: 200,
      damping: 50,
    },
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      type: 'spring',
      stiffness: 200,
      damping: 50,
    },
  },
})

function getTransitionStates(status) {
  if (['entering', 'entered'].includes(status)) {
    return 'visible'
  } else if (['exiting'].includes(status)) {
    return 'exitedState'
  } else if (['exited'].includes(status)) {
    return 'startState'
  }
}

const PostContainer = styled.div`
  margin: 8rem auto 3rem;
  max-width: 1100px;
  padding: 3rem;
`

const Article = styled.article`
  padding-top: 3rem;
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
      Arial, sans-serif;
    color: #171d20;
  }

  p {
    color: #171d20;
    font-size: 14px;
    font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
      Arial, sans-serif;
  }
`

const Links = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 5rem auto 5rem;
  padding: 3rem;
  max-width: 1100px;
`

const StyledTransitionLink = styled(TransitionLink)`
  color: #171d20;
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
    Arial, sans-serif;
`

class BlogPostTemplate extends React.Component {
  render() {
    //   const post = this.props.data.markdownRemark;
    //   const siteTitle = this.props.data.site.siteMetadata.title;
    //   const author = this.props.data.site.siteMetadata.author;
    const { previous, next } = this.props.pageContext

    const { markdownRemark } = this.props.data // data.markdownRemark holds our post data
    const { frontmatter, html } = markdownRemark

    return (
      <Page>
        <TransitionState>
          {({ transitionStatus: status }) => {
            return (
              <PageTransitionStates pose={getTransitionStates(status)}>
                <div className="blog-post-container">
                  <div className="blog-post">
                    <PostContainer>
                      <h1>{frontmatter.title}</h1>
                      <h2>{frontmatter.date}</h2>
                      <Article
                        className="blog-post-content"
                        dangerouslySetInnerHTML={{ __html: html }}
                      />
                    </PostContainer>
                  </div>
                </div>
                <Links>
                  {previous && (
                    <StyledTransitionLink
                      to={previous.frontmatter.path}
                      rel="previous"
                      exit={{
                        length: 0.4,
                      }}
                      entry={{
                        delay: 0.3,
                        length: 0.8,
                      }}
                    >
                      ← {previous.frontmatter.title}
                    </StyledTransitionLink>
                  )}
                  <div />
                  {next && (
                    <StyledTransitionLink
                      to={next.frontmatter.path}
                      rel="next"
                      exit={{
                        length: 0.4,
                      }}
                      entry={{
                        delay: 0.3,
                        length: 0.8,
                      }}
                    >
                      {next.frontmatter.title} →
                    </StyledTransitionLink>
                  )}
                </Links>
              </PageTransitionStates>
            )
          }}
        </TransitionState>
      </Page>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query($path: String) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        path
        title
      }
    }
  }
`
